(() => {
  const selector = [
    '[data-aleisha-category-track]',
    '[data-apc-track]',
    '[data-reels-track]',
    '[data-testimonial-track]',
    '.aleisha-featured-products__tabs',
  ].join(',');

  const initialized = new WeakSet();

  const enablePointerSwipe = (track) => {
    if (!(track instanceof HTMLElement) || initialized.has(track)) return;

    initialized.add(track);
    track.dataset.aleishaSwipeReady = '';

    let pointerId = null;
    let startX = 0;
    let startScrollLeft = 0;
    let moved = false;
    let blockClick = false;

    const finish = (event) => {
      if (pointerId === null || (event && event.pointerId !== pointerId)) return;

      if (track.hasPointerCapture?.(pointerId)) {
        track.releasePointerCapture(pointerId);
      }

      pointerId = null;
      track.classList.remove('is-pointer-dragging');

      if (moved) {
        blockClick = true;
        window.setTimeout(() => {
          blockClick = false;
          moved = false;
        }, 0);
      }
    };

    track.addEventListener('pointerdown', (event) => {
      if (event.pointerType === 'touch' || event.button !== 0) return;
      if (track.scrollWidth <= track.clientWidth + 2) return;

      pointerId = event.pointerId;
      startX = event.clientX;
      startScrollLeft = track.scrollLeft;
      moved = false;
      track.setPointerCapture?.(pointerId);
    });

    track.addEventListener('pointermove', (event) => {
      if (pointerId === null || event.pointerId !== pointerId) return;

      const distance = event.clientX - startX;
      if (!moved && Math.abs(distance) > 5) {
        moved = true;
        track.classList.add('is-pointer-dragging');
      }

      if (!moved) return;
      event.preventDefault();
      track.scrollLeft = startScrollLeft - distance;
    });

    track.addEventListener('pointerup', finish);
    track.addEventListener('pointercancel', finish);
    track.addEventListener('lostpointercapture', finish);
    track.addEventListener('dragstart', (event) => event.preventDefault());
    track.addEventListener(
      'click',
      (event) => {
        if (!blockClick && !moved) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        blockClick = false;
        moved = false;
      },
      true
    );
  };

  const initialize = (context = document) => {
    if (context instanceof Element && context.matches(selector)) enablePointerSwipe(context);
    context.querySelectorAll?.(selector).forEach(enablePointerSwipe);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  } else {
    initialize();
  }

  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
